module.exports = __webpack_public_path__ + "assets/img/slogan-575b0c0e.png";